import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("admin@popcrn.de");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) {
      toast.success("Willkommen im POPCRN HQ");
      nav("/");
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Left – Brand panel */}
      <div className="hidden md:flex flex-col relative auth-radial text-white p-12 overflow-hidden">
        <div className="relative z-10 flex items-center gap-3">
          <img src="/logos/logo-white.png" alt="POPCRN" className="h-10 w-auto" />
          <div className="pl-3 border-l border-white/20">
            <div className="overline text-white/60 leading-none">ERP Command Center</div>
          </div>
        </div>

        <div className="relative z-10 mt-auto">
          <h1 className="font-display font-black text-6xl leading-[0.95] tracking-tight">
            Alles.<br />
            Unter.<br />
            <span className="text-[var(--pop-yellow)]">Kontrolle.</span>
          </h1>
          <p className="mt-6 max-w-md text-white/70 leading-relaxed">
            Chargen, MHD, Produktion, Lager und Versand – POPCRN ERP verbindet
            Handwerk und Skalierung. Für die knalligste Snack-Brand der Welt.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-3 max-w-md">
            {["Chargen", "MHD", "MRP", "Barcode", "DATEV", "WooCom."].map((t) => (
              <div key={t} className="text-xs font-mono px-3 py-2 rounded-full border border-white/15 bg-white/5 text-center">
                {t}
              </div>
            ))}
          </div>
        </div>
        <div
          aria-hidden
          className="pointer-events-none absolute -bottom-24 -right-24 w-96 h-96 rounded-full"
          style={{ background: "radial-gradient(circle, rgba(235,117,181,0.38) 0%, transparent 60%)" }}
        />
      </div>

      {/* Right – Form */}
      <div className="flex items-center justify-center bg-[var(--bg)] p-6">
        <form
          onSubmit={submit}
          className="w-full max-w-md bg-white rounded-3xl border border-[var(--border)] p-8 shadow-sm"
          data-testid="login-form"
        >
          <div className="overline mb-2">Anmeldung</div>
          <h2 className="font-display font-black text-3xl tracking-tight mb-1">Willkommen zurück</h2>
          <p className="text-sm text-[var(--text-muted)] mb-8">
            Melde dich an, um deine POPCRN-Produktionsstätte zu steuern.
          </p>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs font-semibold uppercase tracking-wider">Email</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 h-11 rounded-xl focus-pop"
                data-testid="login-email"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-semibold uppercase tracking-wider">Passwort</Label>
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5 h-11 rounded-xl focus-pop"
                data-testid="login-password"
              />
            </div>
          </div>

          {error && (
            <div className="mt-4 text-sm text-red-700 bg-red-50 px-3 py-2 rounded-lg" data-testid="login-error">
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={busy}
            className="mt-6 w-full h-11 rounded-full bg-[var(--pop-yellow)] text-black font-bold hover:bg-[var(--pop-yellow-dark)]"
            data-testid="login-submit"
          >
            {busy ? "Prüfe…" : "Einloggen →"}
          </Button>

          <div className="mt-6 text-xs text-[var(--text-muted)]">
            Kein Account? Bitte deinen Admin fragen. POPCRN ist ein internes System.
          </div>
        </form>
      </div>
    </div>
  );
}
